import FILTER_TYPES from '@/components/query/filter-types';

export default {
    id: {
        type: FILTER_TYPES.text,
    },
    email: {
        type: FILTER_TYPES.text,
    },
    ipAddress: {
        type: FILTER_TYPES.text,
    },
    firstName: {
        type: FILTER_TYPES.text,
    },
    lastName: {
        type: FILTER_TYPES.text,
    },
    createdTime: {
        type: FILTER_TYPES.datetime,
    },
    updatedTime: {
        type: FILTER_TYPES.datetime,
    },
    defaultPaymentMethod: {
        type: FILTER_TYPES.text,
    },

    'leadSource/source': {
        type: FILTER_TYPES.text,
    },
    'leadSource/medium': {
        type: FILTER_TYPES.text,
    },
    'leadSource/campaign': {
        type: FILTER_TYPES.text,
    },
    'leadSource/content': {
        type: FILTER_TYPES.text,
    },
    'leadSource/term': {
        type: FILTER_TYPES.text,
    },
    'leadSource/affiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/subAffiliate': {
        type: FILTER_TYPES.text,
    },
    'leadSource/salesAgent': {
        type: FILTER_TYPES.text,
    },
    'leadSource/amount': {
        type: FILTER_TYPES.numeric,
    },
    'leadSource/path': {
        type: FILTER_TYPES.text,
    },
    'leadSource/ipAddress': {
        type: FILTER_TYPES.text,
    },
    'leadSource/clickId': {
        type: FILTER_TYPES.text,
    },
    'leadSource/createdTime': {
        type: FILTER_TYPES.datetime,
    },
    'leadSource/updatedTime': {
        type: FILTER_TYPES.datetime,
    },

    'primaryAddress/firstName': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/lastName': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/address': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/address2': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/organization': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/city': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/region': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/country': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/postalCode': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/email': {
        type: FILTER_TYPES.text,
    },
    'primaryAddress/phoneNumber': {
        type: FILTER_TYPES.text,
    },
};
